module.exports = __webpack_public_path__ + "img/hawaii_scout.be7f8afa.gif";